import { pageRegex } from "../constants/pageRegex";

export const getContentGroup = (pathname: string): string => {
  return pageRegex.find((entry) => entry.regex.test(pathname))?.page || "Other";
};
